import style from "./IndexTab.module.css";

import { Link } from "react-router-dom";
import rectitleimg from "../../assets/images/rectitle.png";
import { useState, useEffect } from "react";
import request from "../../common/request";
export default function Main() {
  const [currentActive, setCurrentActive] = useState(0);

  const [list, setList] = useState([]);
  useEffect(() => {
    request.getColumnList("推荐服务").then((result) => {
      console.log(result.data);
      if (result.data.data.data && result.data.data.data.length > 0) {
        var data = result.data.data.data;
        data.forEach((element) => {
          element.isActive = false;
        });
        setList(data);
      }
      console.log("list", data);
    });
  }, []);

  return (
    <>
      <div className={style.tabbox}>
        <div className={style.tabheader}>
          {list.map((item, index) => {
            return (
              <a
                className={currentActive == index ? style.active : ""}
                onClick={() => {
                  setCurrentActive(index);
                }}
              >
                {item.title}
              </a>
            );
          })}
        </div>
        <div className={style.tabbody}>
          {list.map((item, index) => {
            return (
              <div
                className={
                  style.r0 +
                  " " +
                  (index == currentActive ? style.active : style.inactive)
                }
                //style={{ backgroundImage: `url(${item.big_pic})` }}
              >
                <img src={rectitleimg} />
                <div className={style.cbox}>
                  <div className={style.cheader}>
                    <label>
                      0{index + 1}
                      <span></span>
                    </label>
                    <h2>{item.title}</h2>
                    <p>{item.desc}</p>
                  </div>
                  <p>{item.content}</p>

                  <Link to={`/recommend?id=` + item.id}>查看详情</Link>
                </div>
              </div>
            );
          })}

          {/* {currentActive == 0 && (
            
          )} */}
        </div>
      </div>
    </>
  );
}
